//namespace
window.QJTApp = window.QJTApp || { modules: {} };

QJTApp.modules.home             = QJTApp.modules.home || {};
QJTApp.modules.home.models      = QJTApp.modules.home.models || {};
QJTApp.modules.home.views       = QJTApp.modules.home.views || {};
QJTApp.modules.home.collections = QJTApp.modules.home.collections || {};
QJTApp.modules.home.routes      = QJTApp.modules.home.routes || {};

QJTApp.modules.home.models.SingleItem = Backbone.Model.extend({

  defaults: {
    author: {
      name: 'No Name',
      url: 'http://localhost/qjt2015/trunk/',
      image: 'http://placehold.it/200x200'
    }
  },

  initialize: function(){
    moment.locale(languages_translate.java_message_007);
    this.set('timeAgo', moment.unix(this.get('pubtime')).fromNow());
    this.set('type', this.checkType());
    this.set('imagesLength', this.checkImages());

    console.log('SingleItem - type: ' + this.get('type'));

    ///////////Nested attributes: The Clone Wars///////////
    //var updatedAuthor = _.clone(this.get('author'));
    //updatedAuthor.name = "Kazuhiro";
    //this.set('author', updatedAuthor);
  },

  checkType: function() {
    //se tiver imagens...
    if (this.has('images')) {
      //se for tiver título (é News)...
      if(this.has('title')) {
        //pega a quantidade de imagens
        switch(this.get('images').length) {
          case 1:
            //type 13 (News texto + foto)
            return 13;
          case 2:
            //type 14 (News texto + 2 fotos)
            return 14;
          case 3:
            //type 15 (News texto + 3 fotos)
            return 15;
          default:
            //type 16 (News texto + mais de 3 fotos)
            return 16;
        }
      //se não tiver título (é Post)...
      } else {
        //se tiver texto...
        if (this.has('text')) {
          //pega a quantidade de imagens
          switch(this.get('images').length) {
            case 1:
              //type 3 (Post texto + 1 foto)
              return 3;
            case 2:
              //type 5 (Post texto + 2 fotos)
              return 5;
            case 3:
              //type 7 (Post texto + 3 fotos)
              return 7;
            default:
              //type 9 (Post texto + mais de 3 fotos)
              return 9;
          }
        //se não tiver texto...
        } else {
          //pega a quantidade de imagens
          switch(this.get('images').length) {
            case 1:
              //type 2 (Post só 1 foto)
              return 2;
            case 2:
              //type 4 (Post 2 fotos)
              return 4;
            case 3:
              //type 6 (Post 3 fotos)
              return 6;
            default:
              //type 8 (Post mais de 3 fotos)
              return 8;
          }
        }  
      }
    //se não tiver imagens...
    } else {
      //se for tiver título (é News ou Torneio)...
      if (this.has('title')) {
        console.log('no image, has title!');
        //se tiver período (é Torneio)...
        if(this.has('status')) {
          //type 17 (Torneio)  
          return 17;
        } else {
          //type 12 (News texto)
          return 12;
        }
      } else {
        //type 1 (Post só texto)
        return 1;
      }
    } 
  },

  checkImages: function() {
    //se tiver imagens
    if (this.has('images')) {
      //retorna o número de imagens
      return this.get('images').length;
    } else {
      //retorna zero
      return 0;
    }
  },

  updateType: function() {
    this.set('type', this.checkType());
  }

});
